var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDipoleAntenna(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 662,
    height: 302,
    style: {
      width: 662,
      height: 302,
      background: "transparent",
      fill: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "role-diagram-draw-area",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "shapes-region",
    style: {
      stroke: "black",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "arrow-line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection real",
    strokeDasharray: "",
    d: "  M70.23,112.34 L326.01,112.34",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 2,
      fill: "none",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "arrow-line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection real",
    strokeDasharray: "",
    d: "  M341.72,112.34 L595.26,112.34",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 2,
      fill: "none",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "arrow-line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection real",
    strokeDasharray: "",
    d: "  M326.01,112.34 L327.13,224.73",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 2,
      fill: "none",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "arrow-line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection real",
    strokeDasharray: "",
    d: "  M341.72,112.34 L342.84,224.73",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 2,
      fill: "none",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "arrow-line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection real",
    strokeDasharray: "",
    d: "  M74.72,82.32 L595.5,85.31",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 1,
      fill: "none",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    transform: "matrix(-0.9999834136273441,-0.005759554687996521,0.005759554687996521,-0.9999834136273441,597.4999999999999,85.32170000012009)",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M10.93,-3.29 Q4.96,-0.45 0,0 Q4.96,0.45 10.93,3.29"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "arrow-line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection real",
    strokeDasharray: "",
    d: "  M144.96,82.85 L76.72,82.33",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 1,
      fill: "none",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    transform: "matrix(0.9999705131786779,0.007679373227781971,-0.007679373227781971,0.9999705131786779,74.71848739495798,82.31973728825773)",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: " M10.93,-3.29 Q4.96,-0.45 0,0 Q4.96,0.45 10.93,3.29"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "arrow-line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection real",
    strokeDasharray: "",
    d: "  M63.5,262.44 L320.09,261.6",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 1,
      fill: "none",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    transform: "matrix(-0.9999945016606114,0.003316119501060085,-0.003316119501060085,-0.9999945016606114,322.0861344537815,261.59319798728876)",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: " M10.93,-3.29 Q4.96,-0.45 0,0 Q4.96,0.45 10.93,3.29"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "arrow-line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "connection real",
    strokeDasharray: "",
    d: "  M77.17,262.44 L65.5,262.44",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 1,
      fill: "none",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    transform: "matrix(1,-2.4492935982947064e-16,2.4492935982947064e-16,1,63.5,262.4375)",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: " M10.93,-3.29 Q4.96,-0.45 0,0 Q4.96,0.45 10.93,3.29"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 660,
    height: 300,
    style: {
      width: 660,
      height: 300,
      fontFamily: "Asana-Math, Asana",
      background: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 142,
    y: 38.96875,
    style: {
      whiteSpace: "pre",
      stroke: "none",
      fill: "rgb(0,0,0)",
      fillOpacity: 1,
      fontSize: "25.950000762939453px",
      fontFamily: "Arial, Helvetica, sans-serif",
      fontWeight: "normal",
      fontStyle: "normal",
      dominantBaseline: "text-before-edge",
      textDecoration: "none"
    }
  }, "L")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 126.171875,
    y: 222.09375,
    style: {
      whiteSpace: "pre",
      stroke: "none",
      fill: "rgb(0,0,0)",
      fillOpacity: 1,
      fontSize: "25.950000762939453px",
      fontFamily: "Arial, Helvetica, sans-serif",
      fontWeight: "normal",
      fontStyle: "normal",
      dominantBaseline: "text-before-edge",
      textDecoration: "none"
    }
  }, "l"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDipoleAntenna);
export default __webpack_public_path__ + "static/media/dipole-antenna.4703051b6521a6a5f22498bf02401d3a.svg";
export { ForwardRef as ReactComponent };